export default "__VITE_ASSET__$Xt0Ws7Q__"